export default __webpack_public_path__ + "static/media/visa.cfef4d77.png";